import {graphql} from "gatsby";
import React from "react";

import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";
import SeoMetaStuff from "../components/SeoMetaStuff";
import StructuredData from "../components/StructuredData";
import SanityRichText from "../components/commons/SanityRichText";

const Termsofuse = ({data}) => {
  const cmsRef = data.allSanityPols.nodes[0];
  const seoData = data.allSanitySeoMeta.nodes[0];

  return (
    <>
      {seoData && <SeoMetaStuff data={seoData} />}
      <StructuredData />
      <div className='siteWrap tou'>
        <Header />
        <SanityRichText className='blocks' blocks={cmsRef._rawPContent} />
        <Footer />
      </div>
    </>
  );
};

export const query = graphql`
  {
    allSanityPols(filter: {pTitle: {eq: "Terms of Use"}}) {
      nodes {
        pTitle
        _rawPContent
      }
    }
    allSanitySeoMeta(filter: {page: {eq: "termsofuse"}}) {
      nodes {
        title
        canUrl
        tags {
          content
          type {
            attributeType
            attributeValue
          }
        }
      }
    }
  }
`;

export default Termsofuse;
